export enum TimeOffStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  ADD_DOCUMENTATION = "ADD DOCUMENTATION",
  CANCELLED = "CANCELLED",
  PENDING_CANCELLATION = "PENDING CANCELLATION",
}

export enum TimeOffActions {
  ADD_DOCUMENTATION = "ADD DOCUMENTATION",
  APPROVE = "APPROVE",
  CANCEL = "CANCEL",
  REJECT = "REJECT",
}
